/* Portado VERBATIM desde boston_ia/index.html — logica original respetada.
   Fuente: C:\\xampp\\htdocs\\boston_ia\\index.html */
function normalizeReplacementChars(s) {
  // CHANGE KEY de Sabre (¤): en .sst/.ssc legacy viaja como byte 0x01.
  // Si se pierde, "51-33¤" (BORRAR remarks 1-33) parece un alta "51-33".
  s = String(s).replace(/\u0001/g, '¤')
  // 0x15 = tecla de transmision legacy (equivale a {ENTER} al final del comando):
  // se elimina para que los comandos queden limpios ("5.CALLE-X\x15" → "5.CALLE-X")
  s = s.replace(/\u0015/g, '')
  return s.split(/\r?\n/).map(line => {
    const trimmed = line.trim();
    if (/^�.*�\s*(;.*)?$/.test(trimmed)) {
      // Reemplaza el primer y ultimo � de la linea por » y «
      return line.replace(/^(\s*)�/, '$1»').replace(/�(\s*)(;.*)?$/, '«$1$2');
    }
    return line;
  }).join('\n');
}

class ScribeParser {
  constructor() { this.lines = []; this.cursor = 0; this.unparsed = []; }

  parse(source) {
    this.lines = source.split(/\r?\n/).map((raw, i) => ({
      num: i + 1, raw, trimmed: raw.trim(),
    }));
    this.cursor = 0; this.unparsed = [];
    const nodes = this._block(() => false);
    return {
      nodes,
      defines: nodes.filter(n => n.kind === 'Define'),
      labels: nodes.filter(n => n.kind === 'Label'),
      subs: nodes.filter(n => n.kind === 'Sub'),
      unparsed: this.unparsed,
    };
  }

  _block(terminator) {
    const out = [];
    while (this.cursor < this.lines.length) {
      const line = this.lines[this.cursor];
      if (terminator(line)) break;
      const node = this._line(line);
      if (node) out.push(node);
      else this.cursor++;
    }
    return out;
  }

  _line(line) {
    const t = line.trimmed;
    if (t === '') return null;
    if (t.startsWith(';')) {
      this.cursor++;
      return { kind:'Comment', line:line.num, raw:line.raw, text:t.slice(1).trim() };
    }
    const def = this._tryDefine(line); if (def) return def;
    const dflt = this._tryDefault(line); if (dflt) return dflt;
    if (/^[A-Za-z_][\w]*:\s*(;.*)?$/.test(t) &&
        !/^(SUB|END|IF|ELSEIF|ELSE|ENDIF|ENDSUB|REPEAT|UNTIL)\b/i.test(t)) {
      this.cursor++;
      return { kind:'Label', line:line.num, raw:line.raw, name:t.replace(/:.*$/,'') };
    }
    if (/^WINDOW\b/i.test(t)) return this._win();
    if (/^MENU\b/i.test(t))   return this._menu();
    if (/^IF\b/i.test(t))     return this._if();
    if (/^SUB\b/i.test(t))    return this._sub();
    if (/^REPEAT\b/i.test(t)) return this._repeat();
    if (/^GOTO\b/i.test(t)) return this._simple(line,'Goto');
    if (/^CALL\b/i.test(t)) return this._simple(line,'Call');
    if (/^EXIT\b/i.test(t)) { this.cursor++; return {kind:'Exit',line:line.num,raw:line.raw}; }
    if (/^RETURN\b/i.test(t)) { this.cursor++; return {kind:'Return',line:line.num,raw:line.raw}; }
    if (/^CHAIN\b/i.test(t)) return this._simple(line,'Chain');
    if (/^SPAWN\b/i.test(t)) return this._simple(line,'Spawn');
    if (/^EXTERNAL\b/i.test(t)) {
      const vars = (t.match(/\[([^\]]+)\]/g) ?? []).map(s => s.slice(1,-1));
      this.cursor++;
      return { kind:'External', line:line.num, raw:line.raw, variables:vars };
    }
    if (/^WAIT\b/i.test(t)) { this.cursor++; return {kind:'Wait',line:line.num,raw:line.raw}; }
    if (/^READ\b/i.test(t))  return this._read(line);
    if (/^WRITE\b/i.test(t)) return this._write(line);
    if (/^OPEN\b/i.test(t))  return this._open(line);
    const cmd = this._emu(line); if (cmd) return cmd;
    const am = t.match(/^\[([^\]]+)\]\s*=\s*(.+?)\s*(;.*)?$/);
    if (am) {
      this.cursor++;
      return { kind:'Assignment', line:line.num, raw:line.raw, variable:am[1], expression:am[2].trim() };
    }
    this.unparsed.push({ line:line.num, raw:line.raw });
    this.cursor++;
    return { kind:'Raw', line:line.num, raw:line.raw };
  }

  _tryDefine(line) {
    const m = line.trimmed.match(/^DEFINE\s*\[\s*([^=\]]+)\s*=\s*([^\]]+)\s*\]/i);
    if (!m) return null;
    const p = m[2].split(':');
    this.cursor++;
    return {
      kind:'Define', line:line.num, raw:line.raw,
      variable:m[1].trim(), type:(p[0]||'').trim(),
      length:p[1] ? Number(p[1].trim()) : undefined,
      mandatory:(p[2]||'').trim().toUpperCase()==='MAND',
      fill:(p[3]||'').trim().toUpperCase()==='FILL',
      defaultValue:(p[4]||'').trim()||undefined,
      description:(p[5]||'').trim()||undefined,
    };
  }
  _tryDefault(line) {
    const m = line.trimmed.match(/^DEFAULT\s*\[\s*([^\]]+)\s*\]\s*=\s*(.+?)\s*(;.*)?$/i);
    if (!m) return null;
    this.cursor++;
    return { kind:'Default', line:line.num, raw:line.raw, variable:m[1].trim(), expression:m[2].trim() };
  }
  _simple(line,kind) {
    const arg = line.trimmed.replace(/^(GOTO|CALL|CHAIN|SPAWN)\s+/i,'').replace(/:\s*$/,'').trim();
    this.cursor++;
    if (kind==='Goto'||kind==='Call') return { kind, line:line.num, raw:line.raw, label:arg };
    return { kind, line:line.num, raw:line.raw, scriptName:arg };
  }
  _emu(line) {
    const t = line.trimmed;
    const m1 = t.match(/^»(.+)«\s*(;.*)?$/);
    if (m1) { this.cursor++; return {kind:'EmulatorCmd',line:line.num,raw:line.raw,command:m1[1]}; }
    const m2 = t.match(/^>>(.+)<<\s*(;.*)?$/);
    if (m2) { this.cursor++; return {kind:'EmulatorCmd',line:line.num,raw:line.raw,command:m2[1]}; }
    // Tolerancia: si la linea empieza y termina con U+FFFD (chevrones
    // corruptos por encoding), la tratamos como comando GDS igual.
    const m3 = t.match(/^�(.+)�\s*(;.*)?$/);
    if (m3) { this.cursor++; return {kind:'EmulatorCmd',line:line.num,raw:line.raw,command:m3[1]}; }
    return null;
  }
  _win() {
    const head = this.lines[this.cursor]; this.cursor++;
    const meta = this._hrc(head.trimmed);
    const body = [];
    while (this.cursor < this.lines.length) {
      const l = this.lines[this.cursor];
      if (/^ENDWINDOW\b/i.test(l.trimmed)) { this.cursor++; break; }
      body.push(l.raw); this.cursor++;
    }
    return { kind:'Window', line:head.num, raw:head.raw, ...meta, body:body.join('\n') };
  }
  _menu() {
    const head = this.lines[this.cursor]; this.cursor++;
    const meta = this._hrc(head.trimmed);
    const items = [];
    while (this.cursor < this.lines.length) {
      const l = this.lines[this.cursor];
      if (/^ENDMENU\b/i.test(l.trimmed)) { this.cursor++; break; }
      const im = l.trimmed.match(/^"([^"]*)"\s*(;.*)?$/);
      if (im) {
        const label = im[1]; this.cursor++;
        const body = this._block(ln =>
          /^ENDMENU\b/i.test(ln.trimmed) || /^"[^"]*"\s*(;.*)?$/.test(ln.trimmed));
        items.push({ label, body });
        continue;
      }
      this.cursor++;
    }
    return { kind:'Menu', line:head.num, raw:head.raw, ...meta, items };
  }
  _if() {
    const head = this.lines[this.cursor];
    const t = head.trimmed;
    const one = t.match(/^IF\s+(.+?)\s+THEN\s+(.+?)(?:\s+ELSE\s+(.+?))?\s+ENDIF\s*(;.*)?$/i);
    if (one) {
      this.cursor++;
      return { kind:'If', line:head.num, raw:head.raw, condition:one[1],
        thenBody:[{kind:'Raw',line:head.num,raw:one[2]}], elseIfs:[],
        elseBody:one[3]?[{kind:'Raw',line:head.num,raw:one[3]}]:undefined };
    }
    const mh = t.match(/^IF\s+(.+?)(?:\s+THEN)?\s*(;.*)?$/i);
    const condition = mh ? mh[1].trim() : '';
    this.cursor++;
    if (this.cursor < this.lines.length && /^THEN\s*(;.*)?$/i.test(this.lines[this.cursor].trimmed)) this.cursor++;
    const thenBody = this._block(ln =>
      /^ELSE\b/i.test(ln.trimmed) || /^ELSEIF\b/i.test(ln.trimmed) || /^ENDIF\b/i.test(ln.trimmed));
    const elseIfs = []; let elseBody;
    while (this.cursor < this.lines.length && /^ELSEIF\b/i.test(this.lines[this.cursor].trimmed)) {
      const ml = this.lines[this.cursor].trimmed.match(/^ELSEIF\s+(.+?)(?:\s+THEN)?\s*(;.*)?$/i);
      const ec = ml ? ml[1] : '';
      this.cursor++;
      if (this.cursor < this.lines.length && /^THEN\s*(;.*)?$/i.test(this.lines[this.cursor].trimmed)) this.cursor++;
      const body = this._block(ln =>
        /^ELSE\b/i.test(ln.trimmed) || /^ELSEIF\b/i.test(ln.trimmed) || /^ENDIF\b/i.test(ln.trimmed));
      elseIfs.push({ condition:ec, body });
    }
    if (this.cursor < this.lines.length && /^ELSE\b/i.test(this.lines[this.cursor].trimmed)) {
      this.cursor++;
      elseBody = this._block(ln => /^ENDIF\b/i.test(ln.trimmed));
    }
    if (this.cursor < this.lines.length && /^ENDIF\b/i.test(this.lines[this.cursor].trimmed)) this.cursor++;
    return { kind:'If', line:head.num, raw:head.raw, condition, thenBody, elseIfs, elseBody };
  }
  _sub() {
    const head = this.lines[this.cursor];
    const m = head.trimmed.match(/^SUB\s+([A-Za-z_][\w]*):?\s*(;.*)?$/i);
    const name = m ? m[1] : 'UNNAMED';
    this.cursor++;
    const body = this._block(ln => /^ENDSUB\b/i.test(ln.trimmed));
    if (this.cursor < this.lines.length) this.cursor++;
    return { kind:'Sub', line:head.num, raw:head.raw, name, body };
  }
  _repeat() {
    const head = this.lines[this.cursor]; this.cursor++;
    const body = this._block(ln => /^UNTIL\b/i.test(ln.trimmed));
    let untilCondition = '';
    if (this.cursor < this.lines.length) {
      const u = this.lines[this.cursor].trimmed;
      const m = u.match(/^UNTIL\s+(.+?)\s*(;.*)?$/i);
      untilCondition = m ? m[1] : '';
      this.cursor++;
    }
    return { kind:'Repeat', line:head.num, raw:head.raw, body, untilCondition };
  }
  _read(line) {
    const t = line.trimmed;
    const fm = t.match(/FILE\s*=\s*"([^"]+)"|F\s*=\s*"([^"]+)"/i);
    const sourceRaw = (fm?.[1]||fm?.[2]||'').toUpperCase();
    const source = sourceRaw.startsWith('EMUFIND')?'EMUFIND':sourceRaw.startsWith('SABRE')?'SABRE':'FILE';
    const rm = t.match(/\bR\s*=\s*(\d+)/i);
    const cm = t.match(/\bC\s*=\s*(\d+)/i);
    const after = t.split(/F(?:ILE)?\s*=\s*"[^"]+"/i)[1] || '';
    const tokens = []; const re = /\[([^\]]+)\]|"([^"]*)"/g; let m;
    while ((m = re.exec(after))) {
      if (m[1]!==undefined) tokens.push({kind:'Variable',name:m[1]});
      else tokens.push({kind:'Delimiter',value:m[2]});
    }
    this.cursor++;
    return { kind:'Read', line:line.num, raw:line.raw, source,
      filePath:source==='FILE'?sourceRaw:undefined, row:rm?.[1], column:cm?.[1], tokens };
  }
  _write(line) {
    const t = line.trimmed;
    const fm = t.match(/FILE\s*=\s*"([^"]+)"|F\s*=\s*"([^"]+)"/i);
    const tgRaw = (fm?.[1]||fm?.[2]||'').toUpperCase();
    let target = 'FILE';
    if (tgRaw.startsWith('EMUFIND'))  target='EMUFIND';
    else if (tgRaw.startsWith('SABRE')) target='SABRE';
    else if (tgRaw.startsWith('EMULATOR')) target='EMULATOR';
    const rm = t.match(/\bR\s*=\s*(\d+)/i);
    const cm = t.match(/\bC\s*=\s*(\d+)/i);
    const after = t.split(/F(?:ILE)?\s*=\s*"[^"]+"/i)[1] || '';
    const fragments = []; const re = /\[([^\]]+)\]|"((?:[^"\\]|\\.)*)"/g; let m;
    while ((m = re.exec(after))) {
      if (m[1]!==undefined) fragments.push({kind:'Variable',name:m[1]});
      else fragments.push({kind:'Literal',value:m[2]});
    }
    this.cursor++;
    return { kind:'Write', line:line.num, raw:line.raw, target,
      filePath:target==='FILE'?tgRaw:undefined, row:rm?.[1], column:cm?.[1], fragments };
  }
  _open(line) {
    const t = line.trimmed;
    const m = t.match(/OPEN\s+F(?:ILE)?\s*=\s*"([^"]+)"/i);
    this.cursor++;
    return { kind:'Open', line:line.num, raw:line.raw, target:m?m[1]:t };
  }
  _hrc(t) {
    return {
      header:t.match(/H\s*=\s*"([^"]*)"/i)?.[1],
      row:t.match(/\bR\s*=\s*(\d+)/i)?.[1],
      column:t.match(/\bC\s*=\s*(\d+)/i)?.[1],
    };
  }
}

class ScribeToCustomScriptConverter {

  convert(program, opts = {}) {
    const name = opts.scriptName || 'script_importado';
    const title = (opts.title || name).toUpperCase();
    const warnings = [];
    const mappings = [];

    // Indexar DEFINEs por variable
    const defines = {};
    for (const d of program.defines) defines[d.variable] = d;

    // Recorrer nodos y armar forms + postCommands
    const forms = [];
    const postCommands = [];
    let currentForm = null;
    let currentFormIdx = 0;

    const ensureForm = (titleStr) => {
      if (!currentForm) {
        currentFormIdx++;
        currentForm = {
          form: `form${currentFormIdx}`,
          title: titleStr || `FORMULARIO ${currentFormIdx}`,
          title_visible: true,
          remarks: [],
        };
        forms.push(currentForm);
      }
      return currentForm;
    };

    const fieldFromDefine = (def, idx) => ({
      campoForm: `field_${idx}`,
      label: def.description || def.variable,
      mandatory: !!def.mandatory,
      remark: '',
      remark_mask: '',
      source_additional: '',
      typedata: this._mapType(def.type),
      typeremark: 'General',
      datasource: [],
    });

    let fieldCount = 0;

    for (const n of program.nodes) {
      switch (n.kind) {
        case 'Define':
          mappings.push({ line:n.line, scribe:n.raw.trim(), cs:`field ${n.variable} -> typedata ${this._mapType(n.type)}`, auto:true });
          break;
        case 'Window': {
          const form = {
            form: `form${forms.length + 1}`,
            title: (n.header || `FORMULARIO ${forms.length+1}`).toUpperCase(),
            title_visible: true,
            remarks: [],
          };
          const vars = [...new Set([...n.body.matchAll(/\[([A-Za-z_][\w]*)\]/g)].map(m => m[1]))];
          for (const v of vars) {
            const def = defines[v];
            if (def) form.remarks.push(fieldFromDefine(def, fieldCount++));
            else {
              form.remarks.push(fieldFromDefine({ variable:v, type:'A', mandatory:true, description:v }, fieldCount++));
              warnings.push(`Linea ${n.line}: variable [${v}] sin DEFINE explicito.`);
            }
          }
          forms.push(form);
          currentForm = form;
          mappings.push({ line:n.line, scribe:`WINDOW H="${n.header||''}"`, cs:`form "${form.title}" con ${vars.length} fields`, auto:true });
          break;
        }
        case 'EmulatorCmd':
          postCommands.push(this._resolveVars(n.command));
          mappings.push({ line:n.line, scribe:n.raw.trim(), cs:`postCommand: ${this._resolveVars(n.command)}`, auto:true });
          break;
        case 'Menu':
          warnings.push(`Linea ${n.line}: MENU "${n.header||''}" no se traduce 1-a-1. Generamos un select con sus items.`);
          // Generar un form con un select cuyo datasource son los items
          ensureForm(n.header || 'OPCIONES');
          currentForm.remarks.push({
            ...fieldFromDefine({ variable:'opcion', type:'A', mandatory:true, description:'Seleccionar' }, fieldCount++),
            typedata:'select',
            typefield:'select',
            datasource: n.items.map((it, i) => ({ value:`opt_${i}`, text: it.label })),
          });
          mappings.push({ line:n.line, scribe:`MENU H="${n.header||''}"`, cs:`select con ${n.items.length} opciones`, auto:false });
          break;
        case 'If':
          warnings.push(`Linea ${n.line}: IF/THEN/ELSE no tiene traduccion directa en Custom Script. Considera dejar la logica al backend o usar postCommands condicionales.`);
          break;
        case 'Sub': case 'Call': case 'Goto':
          warnings.push(`Linea ${n.line}: ${n.kind} no tiene equivalente en Custom Script.`);
          break;
        case 'Read': case 'Write':
          warnings.push(`Linea ${n.line}: ${n.kind} ${n.source||n.target} no se mapea (Custom Script usa POST al backend, no READ/WRITE).`);
          break;
        case 'Exit':
          mappings.push({ line:n.line, scribe:'EXIT', cs:'(fin del script)', auto:true });
          break;
      }
    }

    // Si no hay forms (todo fue postCommands), creamos uno vacio
    if (forms.length === 0) {
      forms.push({ form:'form1', title:'CONSULTA', title_visible:true, remarks:[] });
    }

    const customScript = {
      name,
      title,
      description: opts.description || `Importado desde .sst (${program.defines.length} defines, ${program.nodes.length} nodos)`,
      tags: ['imported', 'sst'].join(','),
      uuid: opts.uuid || '',
      validateActiveReservation: true,
      sendCommands: postCommands.length > 0,
      orderExecute: true,
      editCatalogues: false,
      reintentos: 0,
      targetEnv: 'stg',
      forms,
      postCommands,
    };

    for (const u of program.unparsed) {
      warnings.push(`Linea ${u.line} no se pudo parsear: ${u.raw.trim()}`);
    }

    return { customScript, mappings, warnings };
  }

  _mapType(t) {
    const u = (t || '').toUpperCase();
    if (u === 'DATE' || u === 'D') return 'date';
    if (u === 'TIME' || u === 'T') return 'text';
    if (u.startsWith('N') || u === 'NUM' || u === '.') return 'number';
    return 'text';
  }

  _resolveVars(s) {
    return s.replace(/\[([A-Za-z_][\w]*)\]/g, (_, v) => `{{${v}}}`);
  }
}

export { normalizeReplacementChars, ScribeParser, ScribeToCustomScriptConverter }
